import type { HTMLAttributes } from "react";

type ButtonGroupProps = HTMLAttributes<HTMLDivElement> & {
  orientation?: "horizontal" | "vertical";
};

/** 提供 shadcn Button Group 的分组语义，视觉样式由业务容器按场景覆盖。 */
export function ButtonGroup({ orientation = "horizontal", ...props }: ButtonGroupProps) {
  return <div role="group" data-slot="button-group" data-orientation={orientation} {...props} />;
}
